import { render } from "./EntryWizardContainer.vue?vue&type=template&id=9ec774d6"
import script from "./EntryWizardContainer.vue?vue&type=script&lang=js"
export * from "./EntryWizardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__